import React, {useCallback} from "react";
import {observer} from "mobx-react-lite";
import Modal from "@mui/joy/Modal";
import {useAppState} from "@stores/AppStateContext";

import {CloseIcon} from "../../../../components/icons/CloseIcon";

import "./SideModal.css"

export interface SideModalProps {
    open: boolean;
    header?: string;
    subHeader?: string;
    children: React.ReactNode;
}

export const SideModal = observer((
    {
        open,
        header,
        subHeader,
        children,
    }: SideModalProps) => {
    const appState = useAppState();

    const handleClose = useCallback(() => {
        appState.setModal(null);
        appState.setContextMenu(null);
    }, []);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                zIndex: 4000,
            }}
        >
            <div className="SideModal">
                <div className="SideModal__close">
                    <CloseIcon
                        className="SideModal__button"
                        additionalPadding={8}
                        size={16}
                        onClick={handleClose}
                    />
                </div>
                <div className="SideModal__header title-large-bold">
                    {header}
                </div>
                {
                    subHeader && (
                        <div className="SideModal__sub-header body-medium">
                            {subHeader}
                        </div>
                    )
                }
                <div className="SideModal__body">
                    {children}
                </div>
            </div>
        </Modal>
    );
});
